//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbSwitch from '@/elements/forms/rb-switch.vue'
import { DATA_MNT_FILTER_NAMES } from '@/scripts/constants/plp'
export default {
  name: 'rb-toggle-block',
  components: {
    RbSwitch,
  },
  inject: ['toggleFacets'],
  props: {
    facet: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dataMntContent() {
      return this.active?.toString()
    },
    dataMntName() {
      if (!this.facet?.key || !DATA_MNT_FILTER_NAMES[this.facet.key]) {
        return ''
      }
      return `data-mnt-filter-${DATA_MNT_FILTER_NAMES[this.facet.key]}`
    },
    value() {
      return (this.facet?.values || [])[0] || {}
    },
    description() {
      return this.value?.description
    },
    active() {
      return this.value?.active
    },
    facetValue() {
      return this.value?.value
    },
  },
  methods: {
    toggle() {
      this.toggleFacets([this.facetValue])
    },
  },
}
